import * as React from 'react';
import { compose, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { Prompt } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { get } from 'lodash';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Card } from 'material-ui/Card';

import TasksFormTask from '@modules/tasks/TasksFormTask';
import TasksFormHistories from '@modules/tasks/TasksFormHistories';
import TasksFormEmployees from '@modules/tasks/TasksFormEmployees';

import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { Tabs } from '@components/tabs';

import { getTask } from '@modules/tasks/_tasksActions';

import * as T from '@modules/tasks/_tasksTypes';

export const enhance = compose<T.TasksFormProps, T.Outter>(
  entityDetailEnhancer<T.TaskEnhancerProps<T.Task> & Partial<T.Task>, T.Task>({
    getEntity: getTask,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [{ label: 'Úkoly', to: '/tasks' }, { label: get(entity, 'task', 'Nový úkol') }]),
  withProps<{}, T.TaskProps>(({ entity }) => ({
    initialValues: {
      ...entity
    }
  })),
  reduxForm({})
);

export const View: React.SFC<T.Outter & T.TasksFormProps> = ({
  handleSubmit,
  closeItem,
  dirty,
  submitSucceeded,
  submitting
}) => (
  <div>
    <Prompt when={dirty && !submitSucceeded && !submitting} message="Vaše změny nebyly uloženy, přesto odejít?" />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <Tabs
          items={[
            { label: 'Úkol', style: { minWidth: 150 }, content: <TasksFormTask /> },
            { label: 'Strážníci', style: { minWidth: 150 }, content: <TasksFormEmployees /> },
            { label: 'Historie', style: { minWidth: 150 }, content: <TasksFormHistories /> }
          ]}
        />

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const TasksForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/tasks/TasksForm.tsx